"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var TransactionRequest_1 = require("../../TransactionRequest");
var GochainTransactionRequest = /** @class */ (function (_super) {
    tslib_1.__extends(GochainTransactionRequest, _super);
    function GochainTransactionRequest() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.data = '0x';
        return _this;
    }
    return GochainTransactionRequest;
}(TransactionRequest_1.TransactionRequest));
exports.GochainTransactionRequest = GochainTransactionRequest;
//# sourceMappingURL=GochainTransactionRequest.js.map